// stores/currentUser.js

import { defineStore } from 'pinia';
import { User } from '@/interfaces/User';
import { Clase } from '@/interfaces/Clase';
import { ProductCart } from '@/interfaces/ProductCart';


export const currentUserStore = defineStore('currentUser', {
  state: () => ({
    user: null as User | null,
    clases: [] as Clase[],
    cart: [] as ProductCart[],
    redirectAfterLogin: null as string | null
  }),

  actions:{
    update(myUser : User)
    {
        this.user = myUser
    }
  }
});